import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

const Product = ({ image, price, name, _id, storeCurrency }) => {
  return (
    <div className="p-2 border">
      <Link to={`/product/${_id}`}>
        <div className="product">
          <img src={image} alt={name} />
          <div className="p-4">
            <h4 className="heading_h4">{name}</h4>
            <p className="heading_h3">
              {storeCurrency} {price}
            </p>
            <p className="anker flex gap-2 items-center pro-icon">
              <EyeOutlined /> View
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Product;
